import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="company_news" />;

export const Route = createFileRoute("/es/noticias/$slug")({
  loader: ({ params }) => loadContentMeta("company_news", params.slug, "es"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/es/noticias/${params.slug}`, loaderData),
  component: ContentPostRoute,
});

